module.exports = __webpack_public_path__ + "img/noises-4.9024844c.jpg";